import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { callPost } from "utils/CommonApi";
import Constants from "common/Constants";
import moment from "moment";
import Header from "components/init/Header";
import Main from "components/init/Main";
import { store } from "Root";
import AlertConfirmPopup from "components/common/AlertConfirmPopup";
import { callNativeLoading } from "bridge/common/CommonBridge";
import { changeStep } from "store/modules/common/initTimeTableReducer";
import { changeInitTimeTableOpen, changeIsInitTimeTablePopupOpen } from "store/modules/common/initTimeTableReducer";
import qs from "qs";

import trimGR20 from "utils/trimGR20";

export const callInitTimeTableAlertPopup = (mmbrSeq, gradCd, userId) => {
    const headerParam = {
        user_id: userId,
    };

    callAlertPopup({
        title: "알림",
        type: "CONFIRM",
        msg: "<strong>표준학습 시간표로 설정하시겠습니까? </strong><br><br> 시간표를 설정하지 않고 나가시면 <br> 자동으로 표준학습 시간표로 설정됩니다.",
    })
        .then((resData) => {
            if (resData) {
                store.dispatch({
                    type: "IS_INIT_TIME_TABLE_POPUP_OPEN",
                    payload: {
                        status: false,
                    },
                });
                callNativeLoading(true);
                let queryParam = {
                    MMBR_SEQ: mmbrSeq,
                    GRAD_CD: gradCd,
                    APL_DT: moment().format("YYYYMMDD"),
                };
                const param = {
                    REQUEST_API: Constants.MID_STUDY_API.INIT_TMTBL_EVENT,
                    HTTP_METHOD: Constants.HTTP_METHOD.POST,
                };
                callPost(
                    headerParam,
                    param,
                    (resData) => {
                        // 최초입회(InitTimeTable) 경로로 메인 진입함을 표시 (메인에서 이벤트팝업 조회 시 파라미터 부착용)
                        sessionStorage.setItem("afterInitTmtbl", "1");
                        window.location.href = "/today/middleStudyToday";
                    },
                    queryParam,
                );
            }
        })
        .catch((err) => {
            console.log("error");
        });
};

/* 공통 모달 호출 */
const callAlertPopup = async (modalInfo) => {
    const reqData = {
        title: modalInfo.title,
        type: modalInfo.type,
        msg: modalInfo.msg,
    };

    return await AlertConfirmPopup(reqData);
};

const InitTimeTable = () => {
    const location = useLocation();
    const history = useHistory();

    const gradCd = useSelector((state) => state.loginReducer.gradCd);
    const userId = useSelector((state) => state.loginReducer.userId);
    const mmbrSeq = useSelector((state) => state.loginReducer.mmbrSeq);

    const dispatch = useDispatch();

    // STEP1: 학년, 학교 선택 한 값
    const [myInitInfo, setMyInitInfo] = useState({
        schlCd: "",
        schlNm: "",
        gradCd: "GR21",
        schlCdFlag: "N", //학교 정보 유무 radio
        primeLevel: "",
        primeWeek: "",
    });
    const [gradeCodes, setGradeCodes] = useState([]);
    const [primeLevelCodes, setPrimeLevelCodes] = useState([]);
    const [primeWeekCodes, setPrimeWeekCodes] = useState([]);
    const [updateGradCd, setUpdateGradCd] = useState("");

    // STEP2: 우리학교 교과서 설정 (과목별 출판사 선택)
    const [saveAatbInfo, setSaveAatbInfo] = useState([]);

    // STEP 단계 선택
    const [stepTab, setStepTabTab] = useState("1");
    const stepToggle = (tab) => {
        if (stepTab !== tab) {
            setStepTabTab(tab);
            dispatch(changeStep(tab));
        }
    };
    const [reset, setReset] = useState(true);

    useEffect(() => {
        callResetGrade();
        callGetGradeCodes();
        callGetPrimeInitInfo();
        dispatch(changeInitTimeTableOpen(true));
    }, []);

    const headerParam = {
        user_id: userId,
    };

    const callResetGrade = () => {
        const queryParam = {
            MMBR_SEQ: mmbrSeq,
        };
        const param = {
            REQUEST_API: Constants.SET_GRADE_API.GET_GRADE_INFO,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };
        callPost(headerParam, param, callbackResetGrade, queryParam);
    };

    const callbackResetGrade = (RRESULT) => {
        const newGradCd = RRESULT.RESP_RESULT.GRAD_CD;

        setUpdateGradCd(newGradCd);

        callMyInfo("", newGradCd);
    };

    // 나의 학교 정보조회
    const callMyInfo = (type, newGradCd) => {
        let queryParam = {
            MMBR_SEQ: mmbrSeq,
        };
        const param = {
            REQUEST_API: Constants.MYPAGE_API.MMBR_SCHLCDS_INFO,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };
        callPost(
            headerParam,
            param,
            (resData) => {
                if (resData.RESP_RESULT.MMBR_SCHL_INFO) {
                    setMyInitInfo({
                        ...myInitInfo,
                        schlCd: resData.RESP_RESULT.MMBR_SCHL_INFO.STD_SCHL_CD,
                        schlNm: resData.RESP_RESULT.MMBR_SCHL_INFO.SCHL_NM,
                        schlCdFlag: "Y",
                        gradCd: type === "INIT" ? updateGradCd : newGradCd,
                    });
                } else {
                    setMyInitInfo({
                        ...myInitInfo,
                        schlCd: "",
                        schlNm: "",
                        schlCdFlag: "N",
                        gradCd: type === "INIT" ? updateGradCd : newGradCd,
                    });
                }
            },
            queryParam,
        );
    };

    const callGetGradeCodes = () => {
        const queryParam = {
            UP_CD: "GRAD_CD",
        };
        const param = {
            REQUEST_API: Constants.MID_STUDY_API.GRADE_CODE_LIST,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };
        callPost(headerParam, param, callbackGetGradeCodes, queryParam);
    };

    const callbackGetGradeCodes = (response) => {
        const gradeCodes = response.RESP_RESULT?.CODE_LIST;

        if (gradeCodes) {
            setGradeCodes(gradeCodes);
        }
    };

    // 프라임 난이도/요일 정보 조회
    const callGetPrimeInitInfo = () => {
        const param = {
            REQUEST_API: Constants.STUDY_PLAN_API.PRIME_INIT_INFO,
            HTTP_METHOD: Constants.HTTP_METHOD.GET,
        };
        callPost(
            headerParam,
            param,
            (response) => {
                const primeCodes = response.RESP_RESULT;
                if (primeCodes) {
                    setPrimeLevelCodes(trimGR20(primeCodes.LVL_CD));
                    setPrimeWeekCodes(trimGR20(primeCodes.PEDC_WEEK_SEQ));
                }
            },
            {},
        );
    };

    useEffect(() => {
        if (primeLevelCodes.length > 0 && primeWeekCodes.length > 0) {
            const level = primeLevelCodes.filter((item) => item.DEF_YN === "Y");
            const week = primeWeekCodes.filter((item) => item.DEF_YN === "Y");

            setMyInitInfo({
                ...myInitInfo,
                primeLevel: level[0].VALUE,
                primeWeek: week[0].VALUE,
            });
        }
    }, [primeLevelCodes, primeWeekCodes]);

    const handleClickClose = () => {
        const grad = updateGradCd !== "" ? updateGradCd : gradCd;
        callInitTimeTableAlertPopup(mmbrSeq, grad);
        dispatch(changeIsInitTimeTablePopupOpen(true));
    };
    const handleClickReset = () => {
        callAlertPopup({
            title: "알림",
            type: "CONFIRM",
            msg: "설정을 초기화 하시겠습니까?",
        })
            .then((resData) => {
                if (resData) {
                    if (stepTab === "1") {
                        callMyInfo("INIT");
                    } else {
                        setReset(!reset);
                    }
                }
            })
            .catch((err) => {
                console.log("error");
            });
    };

    const callInitTimetable = () => {
        const queryParam = {
            MMBR_SEQ: mmbrSeq,
            GRAD_CD: gradCd,
            APL_DT: moment().format("YYYYMMDD"),
        };
        const param = {
            REQUEST_API: Constants.MID_STUDY_API.INIT_TMTBL_EVENT,
            HTTP_METHOD: Constants.HTTP_METHOD.POST,
        };
        callPost(headerParam, param, callbackInitTimetable, queryParam);
    };

    const callbackInitTimetable = () => {
        callNativeLoading(false);
        history.replace("/today/middleStudyToday");
    };

    return (
        <div className="init-schedule-container">
            <Header handleClickClose={handleClickClose} handleClickReset={handleClickReset} title="시간표" />
            <Main
                stepTab={stepTab}
                reset={reset}
                stepToggle={stepToggle}
                myInitInfo={myInitInfo}
                setMyInitInfo={setMyInitInfo}
                saveAatbInfo={saveAatbInfo}
                setSaveAatbInfo={setSaveAatbInfo}
                gradeCodes={gradeCodes}
                primeLevelCodes={primeLevelCodes}
                primeWeekCodes={primeWeekCodes}
            />
        </div>
    );
};

export default InitTimeTable;
